<template>
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-rotate">
    <path d="M14.95 5H13L16.2 8.39L18.82 5H17.04C17.04 2.11 15.15 0 12 0V2.1C14.1 2.1 14.95 3.26 14.95 5ZM0 2C0 1.44772 0.447715 1 1 1H9C9.55228 1 10 1.44772 10 2V10H18C18.5523 10 19 10.4477 19 11V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V15H1C0.447715 15 0 14.5523 0 14V2ZM2 3V13H5V11C5 10.4477 5.44772 10 6 10H8V3H2ZM7 12V18H17V12H7Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: "IconRotate",
  props: {
    color: {
      type: String,
      default: '#212121'
    }
  }
}
</script>
